module.exports = __webpack_public_path__ + "static/media/U1-T2-4-3.fd811ebd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-4-3.svg
// module id = 590
// module chunks = 0